import { render, staticRenderFns } from "./LogisticsChecklist.vue?vue&type=template&id=1085a2fe&scoped=true&"
import script from "./LogisticsChecklist.vue?vue&type=script&lang=js&"
export * from "./LogisticsChecklist.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsChecklist.vue?vue&type=style&index=0&id=1085a2fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1085a2fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
